import axios from "../../../js/project-axios.js";

const list = name => {
    return axios.get("/servicer/app/list", {
        params: {
            name
        }
    });
};

const add = app => {
    return axios.post("/servicer/app/add", app);
};

const edit = app => {
    return axios.post("/servicer/app/edit", app);
};

const resetAppSecret = app => {
    return axios.post("/servicer/app/resetAppSecret", app);
};

export default {
    list,
    add,
    edit,
    resetAppSecret
};